export const COOKIE_KEYS = {
  IS_ADULT: 'isAdult',
}
